import * as PIXI from 'pixi.js';
import {Main} from '../Main';
import {Const} from '../Const';
import {TweenMax,TimelineMax,Sine, Bounce, Power1,Power2, Elastic, Power3} from "gsap";
//プラグインの読み込み
import 'pixi-picture';
import {TimelinePlus} from './TimelinePlus';

export class Logo extends PIXI.Container {

	container:PIXI.Container;
	logos:PIXI.Sprite[] = [];
	logoPos:PIXI.Point[] = [];

	constructor() {
		super();
		this.container = new PIXI.Container();
		this.addChild(this.container);
		Main.instance.stage.addChild(this);
		this.container.y = 420*4;
		//this.alpha = 0;
		for (let i = 0; i < 5; i++) {
			this.logoPos[i] = new PIXI.Point();
			this.logos[i] = new PIXI.Sprite(PIXI.Texture.fromFrame('logo_'+i+'.png'));
			this.logos[i].texture.baseTexture.scaleMode = PIXI.SCALE_MODES.LINEAR;
			this.logos[i].pivot.x=this.logos[i].width*0.5;
			this.logos[i].pivot.y=this.logos[i].height*0.5;
			this.logos[i].alpha = 1;
			this.container.addChild(this.logos[i]);

		}

		this.logoPos[0].x=873 - 873;
		this.logoPos[0].y=0;
		this.logoPos[1].x=976 - 873;
		this.logoPos[1].y=258;
		this.logoPos[2].x=1139 - 873;
		this.logoPos[2].y=128;
		this.logoPos[3].x=1391 - 873;
		this.logoPos[3].y=0;
		this.logoPos[4].x=1680 - 873;
		this.logoPos[4].y=128;


		for (let i = 0; i < 5; i++) {
			this.logos[i].x = this.logoPos[i].x = this.logoPos[i].x + this.logos[i].pivot.x;
			this.logos[i].y = this.logoPos[i].y = this.logoPos[i].y + this.logos[i].pivot.y;
		}

	}

	start(type:string) {
	}

	logoin() {
		TweenMax.to(this.container,0.5,{y:0,	ease:Power2.easeOut,delay:1})
	}

	skip() {
		TweenMax.to(this.container,0.5,{y:0,	ease:Power2.easeOut,delay:0.2})
		//this.container.y = 0;
	}


	resize(w,h,mode,device) {
		//1081;401
		let ratio;
		if(mode) {
			//縦
			if(device === 'sp') {
				ratio = h/401*0.04
			} else {
				ratio = 0.12
			}
		} else {
			if(device === 'sp') {
				ratio = h/401*0.08
			} else {
				ratio = 0.12
			}
		}
		this.scale.y = ratio;
		this.scale.x = ratio;

		if(mode) {
			this.x = (w - this.width)-36;
		} else {
			this.x = (w - this.width) / 2;
		}
		if(mode) {
			//縦
			if(device === 'sp') {
				this.y = h - this.height - (h*0.05);
			} else {
				this.y = h - this.height - 50;
			}
		} else {
			if(device === 'sp') {
				this.y = h - this.height - (h*0.1);
			} else {
				this.y = h - this.height - 60;
			}
		}
	}

	random(min, max){
		return (Math.random() * (max - min)) + min;
	}



}